// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "0057c63ce9a6c1c282b046bc6ba3cb20" + ".css";
};